<template>
  <v-app id="login">
    <v-container>
      <div
        style="display: flex; justify-content: center; align-items: center; height: 80vh;"
      >
        <div v-if="!expired_status">
          <v-card color="primary" dark>
            <v-card-text>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>

          <div class="mt-5">
            <h3>User is being checked, please wait a moment</h3>
          </div>
        </div>

        <div v-else>
          <h2 class="d-flex">
            E-Master auth token has been expired
            <v-icon class="ml-2" color="red">mdi-close-circle</v-icon>
          </h2>
        </div>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import moment from "moment"

export default {
  name: "login",
  props: {
    source: String,
  },
  data() {
    return {
      storage: {
        session: false,
      },
      username: "",
      password: "",
      md5: "",
      dialog: false,
      expired_status: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.login()
    }, 2000)
  },
  methods: {
    login() {
      var self = this
      var token = JSON.parse(atob(self.$route.query.token))
      var url = self.base_url + "login/getUser"
      var current_date = moment().unix()
      var expired_date = token.expired_date

      if (current_date > expired_date) {
        this.expired_status = true

        return false
      }

      this.axios
        .post(url, {
          username: token.email,
          password: token.password,
        })
        .then(function(response) {
          if (response.data.length > 0) {
            window.localStorage.setItem(
              "user_id",
              btoa(response.data[0].USER_ID)
            )
            window.localStorage.setItem(
              "username",
              btoa(response.data[0].USER_NAME)
            )
            window.localStorage.setItem("fullname", btoa(response.data[0].NAME))
            window.localStorage.setItem(
              "departement_id",
              btoa(response.data[0].DEPARTEMENT_ID)
            )
            window.localStorage.setItem(
              "departement_desc",
              btoa(response.data[0].DEPARTEMENT_DESC)
            )
            window.localStorage.setItem(
              "plant_code",
              btoa(response.data[0].plant_code)
            )
            window.localStorage.setItem("role", btoa(response.data[0].ROLE_ID))
            window.localStorage.setItem(
              "server",
              btoa(response.data[0].SERVER_CODE)
            )
            window.localStorage.setItem("email", btoa(response.data[0].EMAIL))
            //  window.localStorage.setItem('company_id', "");
            //  window.localStorage.setItem('company_name', "");
            //setTimeout(() => (

            if (response.data[0].ROLE_ID == "REQ") {
              self.$router.push("/searchRegister")
            } else if (response.data[0].ROLE_ID == "APP") {
              self.$router.push("/listApprove")
            } else if (response.data[0].ROLE_ID == "CAT") {
              self.$router.push("/listCatalog")
            } else {
              self.$router.push("/")
            }

            //), 500);
          } else {
            self.dialog = false
            alert("Incorrect email or password")
          }
        })
    },
  },
}
</script>
